import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from '../AuthProvider';
import { hasAuthToken } from '../utils/authToken';

/**
 * Protected route wrapper that checks if user is authenticated
 * Allows both guests and logged-in users to access
 * Redirects to home if no user is present (shouldn't happen with AuthProvider)
 * 
 * Use StrictAuthWrapper for routes that require logged-in users only
 */
const AuthWrapper: React.FC = () => {
    const { user } = useAuth();
    
    // Allow access if:
    // - User is a guest (user.guest === true), OR
    // - User has a token (logged in)
    // AuthProvider always provides a user, so this should always pass
    const canAccess = user && (user.guest || hasAuthToken());

    return canAccess ? (
        <Outlet />
    ) : (
        <Navigate to="/home" replace />
    );
};

export default AuthWrapper;

/**
 * StrictAuthWrapper - Only allows logged-in users (non-guests)
 * Use this for routes that require a registered account
 */
export const StrictAuthWrapper: React.FC = () => {
    const { user } = useAuth();
    const isLoggedIn = hasAuthToken() && user && !user.guest;

    // Only allow logged-in users (non-guests)
    return isLoggedIn ? (
        <Outlet />
    ) : (
        <Navigate to="/login" replace />
    );
};

